import React, {FC} from "react";
import {useLocale} from "@/contexts/localeContext.tsx";
import {TranslationKeys} from "@/contexts/TranslationKeys.ts";
import {useFormikContext} from "formik";
import { WizardSummaryLayout } from '@/components/wizard/wizard-summary-layout';

interface summaryProps {
    onBack: () => void;
}

const Summary: FC<summaryProps> = ({onBack}) => {
    const {translate} = useLocale();
    const {values} = useFormikContext<any>();

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <span className="text-lg font-bold">{translate.byKey(TranslationKeys.selectedIdpGroup)}</span>
        <div className="flex flex-row">
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.groupName)}:</span>
                <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.groupDescription)}:</span>
            </div>
            <div className="flex flex-col">
                <span className="pt-1 text-sm text-black pl-2">{values.idpGroupName}</span>
                <span className="pt-1 text-sm text-black pl-2">{values.idpGroupDescription}</span>
            </div>
        </div>
        <>
            <span className="pt-4 text-lg font-bold">{translate.byKey(TranslationKeys.selectedPermission)}</span>
            <div className="flex flex-row">
                <div className="flex flex-col">
                    <span className="pt-1 text-sm text-gray-600">{translate.byKey(TranslationKeys.permissionName)}:</span>
                </div>
                <div className="flex flex-col">
                    <span className="pt-1 text-sm text-black pl-2">{values.profileName}</span>
                </div>
            </div>
        </>
    </WizardSummaryLayout>
}

export default Summary;
